import {
  DASHBOARD_START_LOADING_DATA,
  DASHBOARD_END_LOADING_DATA,
  DASHBOARD_FETCH_GROUP_COUNT_DATA,
  DASHBOARD_FETCH_ORGANE_COUNT_DATA,
  DASHBOARD_FETCH_ORGANE_DATA,
  DASHBOARD_FETCH_LATEST_SUBSCRIBERS_DATA,
  DASHBOARD_FETCH_COUNT_ALL_LAST_BY_ORGANE_DATA
} from "../actions/types";

const defaultCountData = {
  total: 0,
  level: {
    local: {
      count: 0,
      percent: 0
    },
    external: {
      count: 0,
      percent: 0
    },
    unaffected: {
      count: 0,
      percent: 0
    },
  },
  sex: {
    male: {
      count: 0,
      percent: 0
    },
    female: {
      count: 0,
      percent: 0
    },
    unaffected: {
      count: 0,
      percent: 0
    },
  }
};

const initialState = {
  groupCountData: {...defaultCountData},
  organeCountData: {
    coordination: null,
    interfederation: null,
    federation: null,
    section: null,
    cell: null
  },
  organeData: [],
  latestSubscribers: [],
  lastByOrganeCountData: {},
  isFetching: false
}

export default function (state = initialState, action) {
  switch (action.type) {
    case DASHBOARD_START_LOADING_DATA:
      return { ...state, isFetching: true };
    
    case DASHBOARD_END_LOADING_DATA:
      return { ...state, isFetching: false };

    case DASHBOARD_FETCH_GROUP_COUNT_DATA:
      return { ...state, groupCountData: action.payload };
    
    case DASHBOARD_FETCH_ORGANE_COUNT_DATA:
      return { ...state, organeCountData: action.payload };

    case DASHBOARD_FETCH_ORGANE_DATA:
      return { ...state, organeData: action.payload };
    
    case DASHBOARD_FETCH_LATEST_SUBSCRIBERS_DATA:
      return { ...state, latestSubscribers: action.payload };
    
    case DASHBOARD_FETCH_COUNT_ALL_LAST_BY_ORGANE_DATA:
      return { ...state, lastByOrganeCountData: action.payload };

    default:
      return state;
  }
}
